/**
 * FlowGuard — Off-Ramp Check (thin page shell).
 *
 * Job selection + path rendering only. Tools, copy, and examples live under
 * components/fiat/offramp/ so jobs/steps can change without editing this file.
 */
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
    OffRampHero,
    OffRampJobChooser,
    OffRampPathView,
    OffRampTipBanner,
    JOB_PATHS,
    readStoredJob,
    writeStoredJob,
    isTipSeen,
    markTipSeen,
} from '../components/fiat/offramp';
import type { JobId } from '../components/fiat/offramp';

export default function FiatOffRamp() {
    const [searchParams] = useSearchParams();
    const hasBridgeParams = Boolean(
        searchParams.get('vpa') || searchParams.get('upi') || searchParams.get('account')
    );
    const [jobId, setJobId] = useState<JobId | null>(() => {
        if (hasBridgeParams) return 'name_exit';
        return readStoredJob();
    });
    const [tipVisible, setTipVisible] = useState(() => !hasBridgeParams && !isTipSeen());

    const selectJob = (id: JobId) => {
        setJobId(id);
        writeStoredJob(id);
    };

    const dismissTip = () => {
        setTipVisible(false);
        markTipSeen();
    };

    return (
        <div className="p-6 max-w-4xl mx-auto space-y-6">
            <OffRampHero />
            {tipVisible && !jobId && <OffRampTipBanner onDismiss={dismissTip} />}
            <OffRampJobChooser
                selected={jobId}
                onSelect={selectJob}
                compact={jobId !== null}
            />
            {jobId && <OffRampPathView job={JOB_PATHS[jobId]} />}
        </div>
    );
}
